/* eslint-disable */
import React from "react";
import { ActionIcon, Tooltip, Loader } from "@mantine/core";
import type { ActionIconProps } from "@mantine/core";
import { useHasPermission } from "./useHasPermission";

type PermissionActionIconProps = ActionIconProps & {
  permission: string;
  hideIfNo?: boolean;
  tooltipIfNo?: string;
  onClick?: (e?: React.MouseEvent) => void;
  "aria-label"?: string;
  title?: string;
};

export const PermissionActionIcon: React.FC<PermissionActionIconProps> = ({
  permission,
  hideIfNo = false,
  tooltipIfNo = "You don't have permission",
  children,
  onClick,
  ...rest
}) => {
  const { has, isLoading } = useHasPermission(permission);

  if (isLoading) {
    return (
      <ActionIcon disabled {...rest}>
        <Loader size="xs" />
      </ActionIcon>
    );
  }

  if (!has) {
    if (hideIfNo) return null;
    return (
      <Tooltip label={tooltipIfNo} withArrow>
        <div style={{ display: "inline-block" }}>
          <ActionIcon disabled {...rest}>
            {children}
          </ActionIcon>
        </div>
      </Tooltip>
    );
  }

  return (
    <ActionIcon onClick={onClick} {...rest}>
      {children}
    </ActionIcon>
  );
};
